import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';
import { ZonePriceTable } from '../../components/Table';

import { CONFIG } from '../../utils/constants';

function EditPricingJob({ title, subtitle }) {
  const dispatch = useDispatch();
  const job = useSelector((state) => state.job);
  const zonePrice = useSelector((state) => state.zonePrice);
  const params = useParams();
  const fetchZonePrice = async () => {
    try {
      dispatch(
        actions.zonePriceAll({ job: params.id, size: CONFIG.infiniteLimit }),
      );
    } catch (error) {
      console.error('Fetching Zone Price Error');
    }
  };

  useEffect(() => {
    dispatch(actions.jobGet(params.id));
    fetchZonePrice();
  }, [params]);

  const handleDeleteZonePrice = async (zoneId) => {
    try {
      const comfirm = window.confirm('ยืนยันการลบโซนราคา');
      if (comfirm) {
        await dispatch(actions.zonePriceDelete(zoneId));
        dispatch(
          actions.zonePriceAll({ job: params.id, size: CONFIG.infiniteLimit }),
        );
        alert('ลบโซนราคาสำเร็จ');
      }
    } catch (error) {
      alert('ลบโซนราคาไม่สำเร็จ');
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderBackButton = () => (
    <div className="flex justify-between my-1">
      <BackButton />
      <Link to={`/jms/pricing/create/${params.id}`}>
        <Button variant="contained">เพิ่ม Zone ราคา</Button>
      </Link>
    </div>
  );
  const renderContent = () => (
    <div className="my-2 ">
      <div>
        <ZonePriceTable
          zonePrices={zonePrice?.rows}
          handleDelete={(id) => handleDeleteZonePrice(id)}
          page={1}
          size={_.size(zonePrice?.rows)}
          total={zonePrice?.total}
        />
      </div>
    </div>
  );

  if (job.isLoading) {
    return <Loading />;
  }
  if (!job.isLoading && job.isCompleted) {
    return (
      <div>
        {renderTitle()}
        {renderBackButton()}
        {renderContent()}
      </div>
    );
  }
  return <Error />;
}

EditPricingJob.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditPricingJob.defaultProps = {
  title: '',
  subtitle: '',
};

export default EditPricingJob;
